"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkIfSpecialPriceApplies;
function checkIfSpecialPriceApplies(fromDate, toDate) {
  if (!toDate && !fromDate) return true;
  var currentTime = new Date().getTime();
  var toDateTime = toDate && new Date(toDate.replace(" ", "T")).getTime();
  var fromDateTime = fromDate && new Date(fromDate.replace(" ", "T")).getTime();
  if (!fromDate) {
    return currentTime <= toDateTime;
  }
  if (!toDate) {
    return currentTime >= fromDateTime;
  }
  return !(currentTime > toDateTime || currentTime < fromDateTime);
}